export enum ButtonVariant {
  PRIMARY = 'primary',
  TEXT = 'text',
  SOFT = 'soft',
  DARK = 'dark',
  SECONDARY = 'secondary',
  DANGER = 'danger',
  EMPTY = '',
  OUTLINED = 'outlined',
  'HOME-YELLOW' = 'home-yellow',
  'HOME-DARK' = 'home-dark',
}
